module.exports = __webpack_public_path__ + "img/user.180e84da.svg";